import React from 'react'
import './index.css'
import Descripcion from './Descripcion'
import Logo from './Logo'

function MoreIncome() {
    return (
        <div className='moreincome'>
            <Descripcion />
            <Logo />
        </div>
    )
}

export default MoreIncome 